import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const AUP = () => {
  return (
    <div className="min-h-screen bg-sonas-bg text-sonas-text p-6 lg:p-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <Link to="/">
          <Button variant="ghost" className="gap-2 text-sonas-dim hover:text-sonas-text">
            <ChevronLeft size={16} /> Back to Grid
          </Button>
        </Link>
        
        <header className="space-y-4">
          <h1 className="text-5xl font-syne font-bold">Acceptable Use</h1>
          <p className="text-sonas-muted">Community standards and restricted behaviors.</p>
        </header>

        <div className="prose prose-invert prose-sonas max-w-none">
          <section className="space-y-4">
            <h2 className="text-2xl font-bold">1. Professional Conduct</h2>
            <p>Sonas is a workspace for professional game development. Users are expected to maintain a level of technical integrity in their prompts and generated systems. Harassment, hate speech, or the generation of discriminatory content via our AI models is strictly prohibited.</p>
          </section>

          <section className="space-y-4 mt-8">
            <h2 className="text-2xl font-bold">2. Security & Integrity</h2>
            <p>The following technical behaviors result in immediate node isolation (suspension):</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Attempting to bypass Roblox chat filters using AI-generated obfuscation.</li>
              <li>Generating "backdoor" scripts designed to give unauthorized administrative access to games.</li>
              <li>Automated scraping of the Sonas API or frontend.</li>
              <li>Sharing account credentials or bypassing multi-node session limits.</li>
            </ul>
          </section>

          <section className="space-y-4 mt-8">
            <h2 className="text-2xl font-bold">3. Resource Stewardship</h2>
            <p>Credits are intended for human-driven architectural planning. Using scripts or bots to trigger high-volume inference requests ("token dumping") is prohibited. We reserve the right to freeze token usage on accounts exhibiting non-human request patterns.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AUP;